import React from 'react';

/**
 * Composant Logo WorkBiFlow - Digital Chrono
 * Affiche le logo avec les lettres "WB" dans un style chronomètre digital
 */
export const WorkBiFlowLogo = ({ size = 128, animated = false, className = '' }) => {
  const uniqueId = `logo-gradient-${size}-${Math.random().toString(36).substr(2, 9)}`;
  
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 128 128" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ display: 'block' }}
    >
      <defs>
        <linearGradient id={uniqueId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#00d2ff', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#3a7bd5', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect x="24" y="34" width="80" height="60" rx="8" fill="#0a0a0a" stroke={`url(#${uniqueId})`} strokeWidth="3"/>
      <text 
        x="64" 
        y="72" 
        fontFamily="'Courier New', monospace" 
        fontSize="36" 
        fontWeight="700" 
        fill={`url(#${uniqueId})`} 
        textAnchor="middle"
      >
        WB
      </text>
      
      {animated && (
        <>
          <circle cx="48" cy="58" r="2.5" fill={`url(#${uniqueId})`}>
            <animate attributeName="opacity" values="1;0.3;1" dur="1s" repeatCount="indefinite"/>
          </circle>
          <circle cx="48" cy="68" r="2.5" fill={`url(#${uniqueId})`}>
            <animate attributeName="opacity" values="1;0.3;1" dur="1s" repeatCount="indefinite"/>
          </circle>
          <circle cx="80" cy="58" r="2.5" fill={`url(#${uniqueId})`}>
            <animate attributeName="opacity" values="1;0.3;1" dur="1s" repeatCount="indefinite"/>
          </circle>
          <circle cx="80" cy="68" r="2.5" fill={`url(#${uniqueId})`}>
            <animate attributeName="opacity" values="1;0.3;1" dur="1s" repeatCount="indefinite"/>
          </circle>
        </>
      )}
      
      <rect x="28" y="38" width="10" height="3" rx="1.5" fill={`url(#${uniqueId})`} opacity="0.6"/>
      <rect x="90" y="38" width="10" height="3" rx="1.5" fill={`url(#${uniqueId})`} opacity="0.6"/>
    </svg>
  );
};

export default WorkBiFlowLogo;

